import { baseFields, FormModel, templateConstraintFields } from '../index'

export function getFormModelKeys(): (keyof FormModel)[] {
  return [
    ...baseFields,
    'discount',
    'priceCap',
    'deliveryFeeMode',
    'discountedCheckSection',
    'availableCustomerSupport',
    'images',
    ...templateConstraintFields,
  ]
}
